import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from 'src/environments/environment';
import { FrameComponent } from './frame/frame/frame.component';
import {
  ROUTE_ROOT,
  ROUTE_NOTIFICATIONS,
  ROUTE_ACCOUNT_SETTINGS,
  ROUTE_DRIVER_HISTORY,
  ROUTE_LOADS,
  ROUTE_UNSUBSCRIBE_EMAIL,
  ROUTE_SUCCESSFUL_UNSUBSCRIBE_EMAIL,
  ROUTE_FAILED_UNSUBSCRIBE_EMAIL,
  ROUTE_JOBS,
  ROUTE_JOB_BOARD,
  ROUTE_REFER_A_FRIEND,
  ROUTE_ADD_TO_HOME_SCREEN,
  ROUTE_TRIPS,
  ROUTE_SHIPMENTS,
  ROUTE_DRIVER_CONSENT,
  ROUTE_DRIVER_DASHBOARD,
  ROUTE_HELP_AND_SUPPORT,
  ROUTE_MY_DOCUMENTS,
  ROUTE_CARRIER_COMPANY,
  ROUTE_INCIDENTS,
  ROUTE_YARD_INSPECTION,
  ROUTE_DRIVER_TIME_CARD,
  ROUTE_DRIVER_RISK_PROFILE,
  ROUTE_ORDER_REPORTS
} from './shared/routes';
import { profileRoutes, ROUTE_PROFILE } from './profile/profile-routing.module';
import { ProfileOutletComponent } from './profile/profile-outlet/profile-outlet.component';
import { DriverGuardService } from './core/guards/driver-guard.service';
import { ConfirmUnsubscribeEmailComponent } from './unsubscribe-email/feature-unsubscribe-email/confirm-unsubscribe-email/confirm-unsubscribe-email.component';
import { SuccessfulUnsubscribeEmailComponent } from './unsubscribe-email/feature-unsubscribe-email/sucessful-unsubscribe-email/successful-unsubscribe-email.component';
import { FailureUnsubscribeEmailComponent } from './unsubscribe-email/feature-unsubscribe-email/failure-unsubscribe-email/failure-unsubscribe-email.component';
import { dqfRouting, ROUTE_DQF } from './driver-qualification-files/driverQualification-routing.module';
import { DqfOutletComponent } from './driver-qualification-files/dqf-outlet/dqf-outlet.component';
import { LoginErrorComponent } from './authentication/login-error/login-error.component';
import { ROUTE_LOGIN_ERROR } from './authentication/shared/routes';
import { ProfileAccessConsentComponent } from './profile/profile-access-consent/profile-access-consent';
import { SHIPMENTS_ROUTE_MY_SHIPMENTS } from './shipments/shared/routes';
import { ShipmentsListComponent } from './shipments/shipments-list/shipments-list.component';
import { DriverProfileDashboardComponent } from './registration/driver-profile-dashboard/driver-profile-dashboard.component';
import { HelpSupportComponent } from './registration/help-support/help-support.component';
import { DriverMyDocumentsComponent } from './registration/driver-my-documents/driver-my-documents.component';
import { ROUTE_DRIVER_JOB } from './driver-job/shared/routes';
import { HelpComponent } from './help/help/help.component';
import { ROUTE_HELP } from './help/shared/routes';
import { ForgotPasswordComponent } from './forgot-password/forgot-password/forgot-password.component';
import { NotificationSentComponent } from './forgot-password/notification-sent/notification-sent.component';
import { ChangePasswordComponent } from './forgot-password/change-password/change-password.component';
import { ROUTE_FORGOT_PASSWORD, ROUTE_NOTIFICATION_SENT, ROUTE_CONFIRM_FORGOT_PASSWORD } from './forgot-password/shared/routes';
import { ResetPasswordComponent } from './reset-password/reset-password/reset-password.component';
import { ROUTE_RESET_PASSWORD } from './reset-password/shared/routes';
import { ReferFriendComponent } from './refer-a-friend/refer-friend/refer-friend.component';

const routes: Routes = [
  {
    path: ROUTE_ROOT,
    component: FrameComponent,
    children: [
      {
        path: '',
        component: ProfileOutletComponent,
        children: [...profileRoutes],
        canActivate: [DriverGuardService]
      },
      {
        path: ROUTE_PROFILE,
        component: ProfileOutletComponent,
        children: [...profileRoutes],
        canActivate: [DriverGuardService]
      },
      {
        path: ROUTE_DRIVER_DASHBOARD,
        component: DriverProfileDashboardComponent,
        canActivate: [DriverGuardService]
      },
      {
        path: ROUTE_HELP_AND_SUPPORT,
        component: HelpSupportComponent,
        canActivate: [DriverGuardService]
      },

      {
        path: ROUTE_REFER_A_FRIEND,
        component: ReferFriendComponent,
        canActivate: [DriverGuardService]
      },
      {
        path: ROUTE_ACCOUNT_SETTINGS,
        loadComponent: () => import('./account-settings/account-settings/account-settings.component').then(m => m.AccountSettingsComponent),
        canActivate: [DriverGuardService]
      },
       {
        path: ROUTE_MY_DOCUMENTS,
        component: DriverMyDocumentsComponent,
        canActivate: [DriverGuardService]
      },
      {
        path: ROUTE_RESET_PASSWORD,
        component: ResetPasswordComponent,
        canActivate: [DriverGuardService]
      },
      {
        path: ROUTE_DQF,
        component: DqfOutletComponent,
        children: [...dqfRouting],
        canActivate: [DriverGuardService]
      },
      {
        path: ROUTE_ADD_TO_HOME_SCREEN,
        loadChildren: () => import('./add-to-home-screen/add-to-home-screen.module').then(m => m.AddToHomeScreenModule),
        canActivate: [DriverGuardService]
      },
      {
        path: ROUTE_DRIVER_HISTORY,
        loadChildren: () => import('./driver-history/driver-history.module').then(m => m.DriverHistoryModule),
        canActivate: [DriverGuardService]
      },
      {
        path: ROUTE_LOADS,
        loadChildren: () => import('./loads/loads.module').then(m => m.LoadsModule),
        canActivate: [DriverGuardService]
      },
      {
        path: ROUTE_JOBS,
        loadChildren: () => import('./jobs/jobs.module').then(m => m.JobsModule),
        canActivate: [DriverGuardService]
      },
      {
        path: ROUTE_JOB_BOARD,
        loadChildren: () => import('./job-board/job-board.module').then(m => m.JobBoardModule),
        canActivate: [DriverGuardService]
      },
      {
        path: ROUTE_TRIPS,
        loadChildren: () => import('./trips/trips.module').then(m => m.TripsModule),
        canActivate: [DriverGuardService]
      },
      {
        path: ROUTE_SHIPMENTS,
        loadChildren: () => import('./shipments/shipments.module').then(m => m.ShipmentsModule),
        canActivate: [DriverGuardService]
      },
      {
        path: SHIPMENTS_ROUTE_MY_SHIPMENTS,
        component: ShipmentsListComponent,
        canActivate: [DriverGuardService]
      },
      {
        path: ROUTE_CARRIER_COMPANY,
        loadChildren: () => import('./carrier-company/carrier-company.module').then(m => m.CarrierCompanyModule),
        canActivate: [DriverGuardService]
      },
      {
        path: ROUTE_INCIDENTS,
        loadChildren: () => import('./incidents/incidents.module').then(m => m.IncidentsModule),
        canActivate: [DriverGuardService]
      },
      {
        path: ROUTE_YARD_INSPECTION,
        loadChildren: () => import('./yard-inspection/yard-inspection.module').then(m => m.YardInspectionModule),
        canActivate: [DriverGuardService]
      },
      {
        path: ROUTE_DRIVER_TIME_CARD,
        loadChildren: () => import('./driver-time-card/driver-time-card.module').then(m => m.DriverTimeCardModule),
        canActivate: [DriverGuardService]
      },
      {
        path: ROUTE_DRIVER_RISK_PROFILE,
        loadComponent: () => import('./driver-risk-profile/driver-risk-profile.component').then(m => m.DriverRiskProfileComponent),
        canActivate: [DriverGuardService],
        canMatch: [() => !!environment.featureFlags?.enableDriverRiskProfile]
      },
      {
        path: ROUTE_ORDER_REPORTS,
        loadComponent: () => import('./order-reports/order-reports.component').then(m => m.OrderReportsComponent),
        canActivate: [DriverGuardService],
        canMatch: [() => !!environment.featureFlags?.enableAbstractTelematicsBundle]
      }
    ],
    canActivate: [DriverGuardService]
  },
  {
    path: ROUTE_UNSUBSCRIBE_EMAIL,
    component: ConfirmUnsubscribeEmailComponent
  },
  {
    path: ROUTE_SUCCESSFUL_UNSUBSCRIBE_EMAIL,
    component: SuccessfulUnsubscribeEmailComponent
  },
  {
    path: ROUTE_FAILED_UNSUBSCRIBE_EMAIL,
    component: FailureUnsubscribeEmailComponent
  },
  { path: ROUTE_LOGIN_ERROR, component: LoginErrorComponent },
  { path: ROUTE_DRIVER_CONSENT, component: ProfileAccessConsentComponent },
  { path: ROUTE_HELP, component: HelpComponent },
  { path: ROUTE_FORGOT_PASSWORD, component: ForgotPasswordComponent },
  { path: ROUTE_NOTIFICATION_SENT, component: NotificationSentComponent },
  { path: ROUTE_CONFIRM_FORGOT_PASSWORD, component: ChangePasswordComponent },
  {
    path: ROUTE_DRIVER_JOB,
    loadChildren: () => import('./driver-job/driver-job.module').then(m => m.DriverJobModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
